export { withPermissions } from './with-permissions';
